/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PublicGamePbpModelDto } from '../../models/public-game-pbp-model-dto';

export interface GameTrackerPublicControllerGetGamePbp$Params {
  userUuid: string;
  localId: string;
  accessHash: string;
  updatedAfter?: string;
}

export function gameTrackerPublicControllerGetGamePbp(http: HttpClient, rootUrl: string, params: GameTrackerPublicControllerGetGamePbp$Params, context?: HttpContext): Observable<StrictHttpResponse<PublicGamePbpModelDto>> {
  const rb = new RequestBuilder(rootUrl, gameTrackerPublicControllerGetGamePbp.PATH, 'get');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.path('localId', params.localId, {});
    rb.path('accessHash', params.accessHash, {});
    rb.query('updatedAfter', params.updatedAfter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PublicGamePbpModelDto>;
    })
  );
}

gameTrackerPublicControllerGetGamePbp.PATH = '/game-tracker-public/user/{userUuid}/games/{localId}/{accessHash}/pbp';
